import React, { useState, useEffect } from 'react';
import './App.scss';
import Layout from '../components/Layout';
import { componentDidMount } from '../components/Lifecycle';
import Carousel from '../components/Carousel';
import NavMenu from '../components/NavMenu';
import IconNav from '../components/IconNav';
import Link from '../components/Link';
import LiveCard from '../components/LiveCard';
import ClassCard from '../components/ClassCard';
import ClassCardTwo from '../components/ClassCardTwo';
import { getPageInfo } from '../services/page';
import Tools from '../util/tools';
import { generateHTMLByModule } from '../constrants/modules';
import { message } from 'antd';

const NavItem = NavMenu.Item;
const { GET } = Tools;


const CLASS_CONFIG = {
  1: 'page-index-carousel',
  2: 'page-index-icon-nav',
  3: 'page-index-class-list',
  4: 'page-index-class-list-two'
}

const App = () => {
  const [PageData, setPageData] = useState({});
  const [PageModules, setPageModules] = useState([]);

  componentDidMount(async () => {
    const res = await getPageInfo({
      app_id: GET.app_id,
      page_id: GET.page_id,
      project_second_id: GET.project_second_id || 1
    }, false);

    if (res.err === 0) {
      const buildModules = [];
      const modules = res.ret.modules;
      modules.map((m, index) => {
        const type = m.module.type;
        if (type === 1 || type === 2 || type === 3 || type === 4) {
          buildModules.push(generateHTMLByModule(m, {
            key: index,
            className: CLASS_CONFIG[type]
          }));
        }
      });
      setPageModules(buildModules);
      // setPageData(res.ret);
    } else {
      message.error(res.msg);
    }
  });

  // 判断空数组模块
  const isEmptyModule = arr => {
    if (typeof arr === 'undefined' || arr.length === 0) {
      return true;
    }
    return false;
  }

  // 顶部导航
  const MenuHTML = (menus) => {

    if (isEmptyModule(menus)) {
      return null;
    }

    return (
      <NavMenu
        key="menu"
        className="page-index-nav"
      >
        {
          menus.map((item, index) => {
            return (
              <NavItem active={index === 0} key={index}>
                <Link
                  className={'link'}
                  href={item.url}
                  target={item.isOpen ? '_blank' : ''}
                >
                  {item.text}
                </Link>
              </NavItem>
            )
          })
        }
      </NavMenu>
    )
  }

  // 轮播
  const BannerHTML = (banners) => {

    if (isEmptyModule(banners)) {
      return null;
    }

    return (
      <Carousel key="banner" className="page-index-carousel">
        {
          banners.map((item, index) => {
            return (
              <Link href={item.link_url} key={index} target={item.isOpen ? '_blank' : ''}>
                <img src={item.img_url} />
              </Link>
            )
          })
        }
      </Carousel>
    )
  }

  // Icon导航
  const IconNavHTML = (icons) => {
    if (isEmptyModule(icons)) {
      return null;
    }
    return (
      <div key="icon" className="page-index-icon-nav">
        <IconNav iconItem={icons} />
      </div>
    )
  }

  // 直播模块
  const LiveCardHTML = (livecard) => {
    if (isEmptyModule(livecard)) {
      return null;
    }
    return (
      <div key="livecard" className="page-index-live-list">
        <LiveCard data={livecard} />
      </div>
    )
  }

  // 课程通栏模块
  const ClassCardHTML = (classcard) => {
    if (isEmptyModule(classcard)) {
      return null;
    }
    return (
      <div key="classcard" className="page-index-class-list">
        <ClassCard data={classcard} />
      </div>
    )
  }

  // 课程一栏两个 模块
  const ClassCardTwoHTML = (classcard) => {
    if (isEmptyModule(classcard)) {
      return null;
    }
    return (
      <div key="classcard-two" className="page-index-class-list-two">
        <ClassCardTwo data={classcard} />
      </div>
    )
  }

  // 页面整合html
  const PageHTML = () => {
    const html = [];
    // html.push(MenuHTML(PageData.menus));
    html.push(BannerHTML(PageData.banners));
    html.push(IconNavHTML(PageData.icons));
    // html.push(LiveCardHTML(PageData.livecard));
    html.push(ClassCardHTML(PageData.classcard));
    html.push(ClassCardTwoHTML(PageData.classcard));
    return html;
  }

  return (
    <Layout activeNav={'index'}>
      <div className="app">
        {/* {PageHTML()} */}
        {PageModules}

      </div>
    </Layout>
  );
};
export default App;
